import React, { useEffect, useState } from 'react'
import { Form, Button, Select, DatePicker, Cascader, TimePicker, Space, Row, Col } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../../tool/axios'
import Scheduling from '../../../component/marketing/Scheduling'
import moment from 'moment';

const { Option } = Select
const { RangePicker } = DatePicker

const format = 'HH:mm';

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 10 }
}

export default function SendCoupon() {

    const [haveNum, setHaveNum] = useState<number>(0)
    const [checkDate, setCheckDate] = useState<any>([])
    const [formInstance] = Form.useForm()
    const [options, setOptions] = React.useState([]);
    const [saleUserList, setsaleUserList] = React.useState<any>([]);
    const [checkDatas, setCheckDatas] = React.useState([]);
    const [scheduleRemove, setScheduleRemove] = React.useState<any>([]);
    const [addVisible, setAddVisible] = React.useState<boolean>(false);
    const [storeObj, setStoreObj] = useState<any>({ id: null })
    const [employee_id_arr, set_employee_id_arr] = React.useState<any>([]);
    const [remove_date, set_remove_date] = React.useState<any>([]);
    const [schedulings, setSchedulings] = React.useState<any>([]);
    const [users, setUsers] = React.useState<any>([]);

    const [scheduleData, setScheduleData] = useState<any>({
        "employee_id_arr": [],
        "schedule_start_date": "",
        "schedule_end_date": "",
        "schedule_remove_date_arr": [
        ],
        "schedule_start_work_turn": "",
        "schedule_end_work_turn": ""
    })

    // 获取城市
    useEffect(() => {
        baseAxiosNoInfo('/global/store_city_list', {
            params: {}
        }).then((res: any) => {
            let optionL: any = res.reduce((acc: any, item: any) => {
                let obj: any = {
                    isLeaf: false,
                    code: item.city_code,
                    name: item.city_name
                }

                acc.push(obj)
                return acc
            }, [])

            setOptions(optionL)
        })
    }, [])

    useEffect(() => {
        let result: any = {}
        result['range-time-picker'] = [moment('09:00', format), moment('18:00', format)]

        formInstance.setFieldsValue(result)
    }, [])

    const disabledDate = (current: any) => {
        return current && current < moment().endOf('day');
    }

    const displayRender = (label: any) => {
        return label[label.length - 1];
    }

    const handleDateChange = (value: any) => {
        set_remove_date(value)
        scheduleData.schedule_remove_date_arr = value;
        setScheduleData(scheduleData)
    }

    const handleChange = (value: string) => {
        set_employee_id_arr(value)
        scheduleData.employee_id_arr = value;
        setScheduleData(scheduleData)
    }

    // 计算两个日期之间的日期
    const getAll = (begin: any, end: any) => {
        var arr: any = [];
        var ab = begin.split("-");
        var ae = end.split("-");

        var db = new Date();
        db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
        var de = new Date();
        de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);

        var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
        var unixDe = de.getTime() - 24 * 60 * 60 * 1000;

        for (var k: any = unixDb; k <= unixDe;) {
            k = k + 24 * 60 * 60 * 1000;
            arr.push(moment(new Date(parseInt(k))).format('YYYY-MM-DD'));
        }

        setCheckDatas(arr)

        setHaveNum(arr.length)
        return arr;
    }

    const dateChange = (date: any, dateString: any) => {
        set_remove_date([])
        setCheckDate(dateString)
        scheduleData.schedule_start_date = dateString[0]
        scheduleData.schedule_end_date = dateString[1]
        setScheduleData(scheduleData)
        setScheduleRemove(getAll(dateString[0], dateString[1]))
    }

    const onChange = (value: any, selectedOptions: any) => {
        let store: any = selectedOptions[selectedOptions.length - 1];

        if (value.length == 2) {
            baseAxiosNoInfo.get("/global/employee_list", { params: { store_id: store.id, position_number: '3,7' } }).then((res: any) => {
                setsaleUserList(res)
                setStoreObj(store)
            })

        } else {
            set_employee_id_arr([])
            setStoreObj({ id: null })
        }
    };

    const changes = () => {
        let obj: any = []

        for (let i in checkDatas) {
            obj.push({ work_date: checkDatas[i], work_turn: `${scheduleData.schedule_start_work_turn}-${scheduleData.schedule_end_work_turn}` })
        }

        scheduleData.schedule_remove_date_arr.map((item: any) => {
            obj.map((citem: any, cindex: number) => {
                if (item == citem.work_date) {
                    obj.splice(cindex, 1)
                }
            })
        })

        let user = []
        for (let i of saleUserList) {
            for (let b of scheduleData.employee_id_arr) {
                if (i.id == b) {
                    user.push(i.user_name)
                }
            }
        }

        setSchedulings(obj)
        setUsers(user)
    }

    const submit = () => {
        axiosHandleEvent.post('/markting_center/schedule/sales/add', scheduleData).then(res => {
        })
    }

    const onFinish = (values: any) => {

        scheduleData.schedule_start_work_turn = values['range-time-picker'][0].format(format)
        scheduleData.schedule_end_work_turn = values['range-time-picker'][1].format(format)
        setScheduleData(scheduleData)

        changes()
        setAddVisible(true)
    }

    const loadData = (selectedOptions: any) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;

        baseAxiosNoInfo.get("/global/store_list_by_city", { params: { city_code: targetOption.code } }).then((res: any) => {
            targetOption.loading = false

            for (let i of res) {
                i.name = i.store_name;
                i.id = i.id;
                i.isLeaf = true;
            }

            targetOption.children = res;
            setOptions([...options]);
        })
    };

    return (<div className="common-level2-edit">
        {/* 营销中心 -> 销售管理 -> 销售排班 -> 新增 */}
        <h2>新增排班</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_other" onFinish={onFinish} >
                <Form.Item label="门店" name="md" rules={[{ required: true, message: '必须选择门店' }]}>
                    <Cascader options={options} fieldNames={{ label: 'name', value: 'name' }} loadData={loadData} onChange={onChange} displayRender={displayRender} />
                </Form.Item>

                <Form.Item label="销售" name="xs" rules={[{ required: true, message: '必须选择销售' }]}>
                    <Select
                        mode="multiple"
                        allowClear
                        disabled={storeObj.id ? false : true}
                        style={{ width: '100%' }}
                        value={employee_id_arr}
                        placeholder={storeObj.id ? '请选择销售' : '请选择门店'}
                        onChange={handleChange}
                    >
                        {saleUserList.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.user_name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="排班日期" name="pb" rules={[{ required: true, message: '必须选择排班日期' }]}>
                    <RangePicker disabledDate={disabledDate} onChange={dateChange} />
                </Form.Item>

                <Form.Item label="排班时段" name="range-time-picker" rules={[{ required: true, message: '必须选择排班时段' }]}>
                    <TimePicker.RangePicker format={format} />
                </Form.Item>

                <Form.Item label="剔除日期">
                    <Select
                        mode="multiple"
                        allowClear
                        disabled={JSON.stringify(checkDate) == '[]' || haveNum == 1 ? true : false}
                        style={{ width: '100%' }}
                        placeholder='请选择剔除日期'
                        value={remove_date}
                        onChange={handleDateChange}
                    >
                        {scheduleRemove.map((item: any) => {
                            return <Option value={item} key={item}>{item}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 6, span: 10 }}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <div className={addVisible ? 'shows' : 'hides'}>
            <div className="headers">确认排班信息</div>

            <CloseOutlined className="close" onClick={() => setAddVisible(false)} />
            <Scheduling position={[1, 2]} type="销售" useData={schedulings} users={users} onChange={changes}></Scheduling>

            <div className="footer">
                <Button style={{ marginLeft: 40, marginTop: 40 }} onClick={() => setAddVisible(false)} >取消</Button>
                <Button type="primary" style={{ marginLeft: 20 }} onClick={submit}>确认</Button>
            </div>
        </div>

        {addVisible ? <div className="mask"></div> : ''}
    </div >)
}